// @flow
import { transparentize } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`position: relative;`;

export const LoadingContainer = styled.div`
    display: ${({ noData }) => (noData ? 'none' : 'block')};
    position: absolute;
    width: 100%;
`;

export const GraphContainer = styled.div`
    display: block;
    height: ${({ height }) => `${height}px`};
    position: relative;
    visibility: ${({ beInvisible }) => (beInvisible ? 'hidden' : 'visible')};
`;

export const NoDataContainer = styled.div`
    background: ${({ theme }) => theme.lightGrey};
    height: ${({ height }) => `${height}px`};
    opacity: ${({ noData }) => (noData ? 1 : 0)};
    position: absolute;
    transition: opacity 0.5s ease-out;
    width: 100%;
`;

export const NoDataMsgContainer = styled.div`
    border: ${({ theme }) => `3px solid ${transparentize(0.5, theme.error)}`};
    border-radius: 3px;
    margin-left: 10%;
    padding: 10px 0;
    text-align: center;
    transform: ${({ containerHeight }) => `translateY(${containerHeight / 2 - 20}px)`};
    width: 80%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/styles.js